<template>
    <!-- <span class="icon" @click="handleClick()" > -->
        <template v-if="localLeagueIconExists.includes(icon)">
            <img :src="require(`../../../static/images/icons/league_icon/${icon}${themeMode === 'dark' ? '__dark' : ''}.png`)"
            :class="className" />
        </template>
        <template v-else>
            <slot name="default" />
        </template>
        <!-- <template v-if="icon === 'german-bundesliga-8'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'uefa-champions-league-103'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'uefa-europa-league-113'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'uefa-nations-league-1864'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'english-premier-league-36'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'spanish-la-liga-31'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'italian-serie-a-34'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'france-ligue-1-11'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'saudi-professional-league-292'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'liga-portugal-1-23'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template>

        <template v-if="icon === 'holland-eredivisie-16'">
            <template v-if="themeMode === 'light'">


            </template>
            <template v-else-if="themeMode === 'dark'">


            </template>
        </template> -->

        
        
        
        
        
        








    <!-- </span> -->
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: 'LeagueIcon',
        data() {
            return {
                localLeagueIconExists: [
                    'german-bundesliga-8',
                    'uefa-champions-league-103',
                    'uefa-europa-league-113',
                    'uefa-nations-league-1864',
                    'english-premier-league-36',
                    'spanish-la-liga-31',
                    'italian-serie-a-34',
                    'france-ligue-1-11',
                    'saudi-professional-league-292',
                    'liga-portugal-1-23',
                    'holland-eredivisie-16'
                ]
            }
        },
        props: {
            icon: String,
            className: String,
            selected: String,
            
        },
        computed: {
            ...mapState(['themeMode','themeModeIndex'])
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>

<style scoped>
.icon {
    display: flex;
}
</style>
